// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__ivaMI","title":"ClientCherryInfo_title__2fFAx","itemText":"ClientCherryInfo_itemText__2nCjh"};